import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useLoader } from "../../Loader";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useSelector } from "react-redux";
import FileUpload from "./FileUpload";

function AddBrandingForm(props) {
  const [formData, setFormData] = useState({
    // type: "",
    state: "",
    district: "",
    city: "",
    counter: "",
    subject: "",
    subjectDetails: "",
    zonalHead: "",
    // reportingManager: "",
    counterKeyPerson: "",
    totalAmount: "",
  });
  const { startLoader, stopLoader } = useLoader();
  const [counters, setCounters] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [validated, setValidated] = useState(false);
  const [salesPersons, setSalesPersons] = useState([]);
  const [files, setFiles] = useState([]);
  const [editFile, setEditfile] = useState([]);

  useEffect(() => {
    fetchCounters();
    fetchEmployees();
  }, []);

  const fetchCounters = () => {
    startLoader();
    utils
      .callAPI("get", `/sales/dealer-distributor-list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setCounters(res);
          stopLoader();
        } else {
          stopLoader();
          setCounters([]);
        }
      })
      .catch((err) => {
        stopLoader();
        setCounters([]);
      });
  };

  const fetchEmployees = () => {
    startLoader();
    utils
      .callAPI("get", `/meeting/branding/list-keypersion`)
      .then((res) => {
        setEmployees(res.result || []);
        stopLoader();
      })
      .catch(() => {
        setEmployees([]);
        stopLoader();
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "totalAmount") {
      const validatedValue = value.replace(/\D/g, "");
      setFormData({ ...formData, [name]: validatedValue });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        let base64 = reader.result;

        // Special case for Word/Excel
        if (
          file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          base64 = base64.replace(
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
            "data:application/xls;base64,"
          );
        } else if (
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          base64 = base64.replace(
            "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,",
            "data:application/msword;base64,"
          );
        }

        resolve(base64);
      };
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      const bodyFormData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props?.rowData?.id);
      }
      bodyFormData.append("state", formData.state);
      bodyFormData.append("city", formData?.city);
      bodyFormData.append("district", formData.district);
      bodyFormData.append("counter", formData.counter);
      bodyFormData.append("subject", formData.subject);
      bodyFormData.append("zonal_head", formData.zonalHead);
      bodyFormData.append("counter_key_person", formData.counterKeyPerson);
      bodyFormData.append("total_amt", formData.totalAmount);

      bodyFormData.append("subject_detail", formData?.subjectDetails);
      const brandingImages = await Promise.all(
        files.map(async (f) => ({
          file: await fileToBase64(f),
        }))
      );

      // ✅ Final structure
      const finalData = [
        {
          file_name: "Branding Photos",
          branding_image: brandingImages,
        },
      ];

      bodyFormData.append("branding_files", JSON.stringify(finalData));

      utils
        .callAPI("post", `/meeting/branding/save`, bodyFormData)
        .then((res) => {
          if (res) {
            const propdata = { mode: "list" };
            props.onChange(propdata);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      startLoader();
      const { rowData } = props;

      setFormData({
        state: rowData.state || "",
        district: rowData.district || "",
        city: rowData.city !== "undefined" ? rowData.city : "",
        counter: rowData.counter || "",
        subject: rowData.subject || "",
        subjectDetails: rowData.subject_detail || "",
        zonalHead: rowData.zonal_head || "",
        counterKeyPerson: rowData.counter_key_person || "",
        totalAmount: rowData.total_amt || "",
      });
      setEditfile(rowData?.document);
      // fetch sales persons for the selected counter
      if (rowData.counter) {
        fetchSalesPersons(rowData.counter);
      }

      stopLoader();
    }
  }, [props.rowData]);

  const handleBackClick = () => {
    const propdata = { mode: "list" };
    props.onChange(propdata);
  };

  const fetchSalesPersons = (dealerId) => {
    if (!dealerId) return;
    startLoader();
    utils
      .callAPI("get", `/sales/assign-sales-persion-list?dealer_id=${dealerId}`)
      .then((res) => {
        setSalesPersons(res || []);
        stopLoader();
      })
      .catch(() => {
        setSalesPersons([]);
        stopLoader();
      });
  };

  const handleCounterChange = (selectedOption) => {
    const selectedCounter = counters.find(
      (c) => String(c.id) === String(selectedOption?.value)
    );

    if (selectedCounter) {
      setFormData((prev) => ({
        ...prev,
        counter: selectedCounter.id,
        state: selectedCounter.company_state?.trim() || "",
        district: selectedCounter.company_district?.trim() || "",
        city: selectedCounter.company_city?.trim() || "",
        selectedCounterData: selectedCounter,
      }));

      fetchSalesPersons(selectedCounter.id); // ✅ Fetch sales persons here
    } else {
      setFormData((prev) => ({
        ...prev,
        counter: "",
        state: "",
        district: "",
        city: "",
        selectedCounterData: null,
      }));
      setSalesPersons([]);
    }
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header>
          <h4>
            {props.rowData && Object.keys(props.rowData).length > 0
              ? "Edit"
              : "Add"}{" "}
            Branding
          </h4>
          <div className="card-header-action">
            <button
              className="btn btn-underline me-2"
              onClick={handleBackClick}
            >
              Back
            </button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mt-4">
                  <Select
                    name="counter"
                    className="bom-productName-select"
                    options={
                      counters?.map((m) => ({
                        value: m.id,
                        label: `${m.companyName} (${m.vendor_type})`,
                      })) || []
                    }
                    value={
                      formData.counter
                        ? {
                            value: formData.counter,
                            label:
                              counters.find(
                                (c) => String(c.id) === String(formData.counter)
                              )?.companyName +
                              " (" +
                              counters.find(
                                (c) => String(c.id) === String(formData.counter)
                              )?.vendor_type +
                              ")",
                          }
                        : null
                    }
                    onChange={handleCounterChange}
                    placeholder="Select Counter..."
                    isClearable
                    classNamePrefix="react-select"
                  />
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="State"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    type="text"
                    name="state"
                    value={formData.state}
                    readOnly
                    placeholder="State"
                  />
                </RB.FloatingLabel>
              </RB.Col>
              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="District"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    type="text"
                    name="district"
                    value={formData.district}
                    readOnly
                    placeholder="District"
                  />
                </RB.FloatingLabel>
              </RB.Col>
              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="City"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    type="text"
                    name="city"
                    value={formData.city}
                    readOnly
                    placeholder="City"
                  />
                </RB.FloatingLabel>
              </RB.Col>

              {/* <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Zonal Head"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Zonal Head"
                    name="zonalHead"
                    value={formData.zonalHead}
                    onChange={handleInputChange}
                  />
                </RB.FloatingLabel>
              </RB.Col> */}
              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Subject"
                  className="floating-label-fancy mt-3"
                >
                  <RB.Form.Select
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Subject...</option>
                    <option value="GSB Board">GSB Board</option>
                    <option value="Flex Board">Flex Board</option>
                    <option value="GSB With In-Shop Branding">
                      GSB With In-Shop Branding
                    </option>
                    <option value="Flex With In-Shop Branding">
                      Flex With In-Shop Branding
                    </option>
                    <option value="Road Side Pole Branding">
                      Road Side Pole Branding
                    </option>
                    <option value="Roadside Hoarding">Roadside Hoarding</option>
                    <option value="Special Branding">Special Branding</option>
                  </RB.Form.Select>
                </RB.FloatingLabel>
              </RB.Col>
            </RB.Row>

            {/* {formData.subjectDetails.map((detail, index) => ( */}
            <RB.Row className="mt-3">
              <RB.Col md={12}>
                <RB.FloatingLabel
                  label={`Subject Detail`}
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    as="textarea"
                    name="subjectDetails"
                    placeholder="Subject Detail"
                    value={formData.subjectDetails}
                    onChange={(e) => handleInputChange(e)}
                  />
                </RB.FloatingLabel>
              </RB.Col>
              {/* <RB.Col md={1} className="mt-4">
                  {index > 0 ? (
                    <button
                      type="button"
                      className="btn btn-flat"
                      onClick={() => removeSubjectDetail(index)}
                    >
                      <Trash />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-flat"
                      onClick={addSubjectDetail}
                    >
                      <AddCircle />
                    </button>
                  )}
                </RB.Col> */}
              {/* ))} */}

              {/*<RB.Col md={6}>
                <RB.FloatingLabel
                  label="Reporting Manager"
                  className="floating-label-fancy"
                >
                  <RB.Form.Select
                    name="reportingManager"
                    value={formData.reportingManager}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Manager...</option>
                    {rmManager.map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.username}
                      </option>
                    ))}
                  </RB.Form.Select>
                </RB.FloatingLabel>
              </RB.Col> */}
              <RB.Col md={6} className="mt-3">
                <RB.FloatingLabel
                  label="Counter Key Person"
                  className="floating-label-fancy"
                >
                  <RB.Form.Select
                    name="counterKeyPerson"
                    value={formData.counterKeyPerson}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Key Person...</option>
                    {salesPersons.map((person) => (
                      <option key={person.id} value={person.id}>
                        {`${person.firstName} ${person.lastName}`}
                      </option>
                    ))}
                  </RB.Form.Select>
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col md={6} className="mt-3">
                <RB.FloatingLabel
                  label="Total Amount"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    name="totalAmount"
                    placeholder="Total Amount"
                    value={formData.totalAmount}
                    onChange={handleInputChange}
                    required
                  />
                </RB.FloatingLabel>
              </RB.Col>
            </RB.Row>
            <FileUpload
              setFiles={setFiles}
              file={files}
              editFile={editFile}
              setEditfile={setEditfile}
            />
            <RB.Row className="mt-4">
              <RB.Col>
                <RB.Button type="submit" variant="primary">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default AddBrandingForm;
